(function () {
  'use strict'

  angular.module('MktzapApp.Controllers')
    .controller('InsuranceErrorInfoController', insuranceErrorInfoController);

  insuranceErrorInfoController.$inject = ['$scope', 'InsuranceErrorInfoService', 'NotificationService', '$rootScope', 'FoundationApi', 'LangService','ngTableParams'];

  function insuranceErrorInfoController($scope, InsuranceErrorInfoService, NotificationService, $rootScope, FoundationApi, LangService, ngTableParams)
  {
    var vm                = this;
    vm.insuranceErrorInfo = '';
    vm.insuranceErrorEdit = '';
    vm.newCardFlag        = '';
    vm.newErrorReturnCode = '';
    vm.newUseCardAgain    = '';
    vm.newMessage         = '';
    vm.insuranceMessageId = '';
    vm.labelsPage         = '';

    getInsuranceErrorInfo();

    LangService
      .getPageLabels({'page': 'menu.insurance.insurance-error-info'})
      .$promise
      .then(function(data) {
        vm.labelsPage = data.lang;
      });

    function getInsuranceErrorInfo() 
    {
      vm.filterInsuranceErrorInfo = '';

      InsuranceErrorInfoService
        .getInsuranceErrorInfo()
        .$promise
        .then(function(data) {
          if (data.insuranceErrorInfo) {
            vm.insuranceErrorInfo = angular.copy(data.insuranceErrorInfo);
            vm.showFilter = angular.copy(data.insuranceErrorInfo);
            vm.getFiltered(angular.copy(data.insuranceErrorInfo));
            return;
          }
          vm.showFilter = []
          vm.insuranceErrorInfo = []
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, vm.labelsPage.error_get);
        });
    }

    vm.getFiltered = () => {
      vm.tableParams = new ngTableParams({
          page: 1,
          count: 30,
      }, {
          total: vm.showFilter.length,
          getData: function($defer, params) {
            $defer.resolve(vm.showFilter.slice((params.page() - 1) * params.count(), params.page() * params.count()))
            params.total(vm.showFilter.length)
          }
      })
    }

    vm.filterItems = () => {
      vm.showFilter = vm.insuranceErrorInfo.filter((insuranceErrorInfo) => {
        var obj = Object.values(insuranceErrorInfo);
        return obj[4].indexOf(vm.filterInsuranceErrorInfo) !== -1;
      });

      vm.getFiltered();
    }

    vm.registerModal = function () {
      FoundationApi.publish('registerModal', 'open');
    }

    $scope.register = function(data)
    {
      if (!vm.newCardFlag || !vm.newErrorReturnCode || !vm.newUseCardAgain || !vm.newMessage) {
        NotificationService.errorHandler(data, vm.labelsPage.error_register_missing_fields);
        return false;
      }

      InsuranceErrorInfoService
        .registerInsuranceErrorInfo({'card_flag': vm.newCardFlag, 'code_error': vm.newErrorReturnCode, 'use_card_again': vm.newUseCardAgain, 'message': vm.newMessage})
        .$promise
        .then(function(data) {
          vm.newCardFlag        = '';
          vm.newErrorReturnCode = '';
          vm.newUseCardAgain    = '';
          vm.newMessage         = '';
          
          getInsuranceErrorInfo();
          NotificationService.successHandler(data.message, vm.labelsPage.success_register)
        })
        .catch(function(data) {
          NotificationService.errorHandler(data, vm.labelsPage.error_register)
        })
    }

    vm.deleteModal = function(id) 
    {
      vm.insuranceMessageId = id;
      FoundationApi.publish('deleteModal', 'open');
    }

    vm.delete = function()
    {
      vm.insuranceErrorInfo.splice(vm.insuranceErrorInfo.indexOf(vm.insuranceMessageId), 1);

      InsuranceErrorInfoService
        .deleteInsuranceErrorInfo({'_id': vm.insuranceMessageId})
        .$promise
        .then(function (data) {
          getInsuranceErrorInfo();
          NotificationService.successHandler(data, vm.labelsPage.success_delete);
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, vm.labelsPage.error_delete);
        });

      FoundationApi.publish('deleteModal', 'close');
    }

    vm.editModal = function (insuranceErrorInfoId) {
      vm.insuranceErrorEdit = {};
      InsuranceErrorInfoService
        .getInsuranceErrorInfoById({ '_id': insuranceErrorInfoId })
        .$promise
        .then(function (data) {
          if (data.insuranceErrorInfo) {
            vm.insuranceErrorEdit = {};
            vm.insuranceErrorEdit = data.insuranceErrorInfo;
            FoundationApi.publish('editModal', 'open');
          } else {
            NotificationService.errorHandler(data, vm.labelsPage.error_edit_message);
          }
        }).catch(function (data) {
          NotificationService.errorHandler(data, vm.labelsPage.error_edit_message);
        });
    }

    vm.edit = function(data)
    {
      if (!vm.insuranceErrorEdit.card_flag || !vm.insuranceErrorEdit.code_error || !vm.insuranceErrorEdit.use_card_again || !vm.insuranceErrorEdit.message) {
        getInsuranceErrorInfo();
        NotificationService.errorHandler(data, vm.labelsPage.error_edit_missing_fields);
        return false;
      }

      InsuranceErrorInfoService
        .editInsuranceErrorInfo({'_id': vm.insuranceErrorEdit._id, 'card_flag': vm.insuranceErrorEdit.card_flag, 'code_error': vm.insuranceErrorEdit.code_error, 'use_card_again': vm.insuranceErrorEdit.use_card_again, 'message': vm.insuranceErrorEdit.message})
        .$promise
        .then(function (data) {
          getInsuranceErrorInfo();
          FoundationApi.publish('editModal', 'close');
          vm.insuranceErrorEdit = {};
          NotificationService.successHandler(data, vm.labelsPage.success_edit);
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, vm.labelsPage.error_edit);
        });
    }

    vm.downloadFile = function() 
    {
      InsuranceErrorInfoService
        .getInsuranceErrorInfo()
        .$promise
        .then(function (data) {
          let itemsFormatted = [];
          let fileTitle = 'insurance_message';
          let headers = {
            card_flag: 'Bandeira do Cartão',
            code_error: "Código do Erro",
            use_card_again: "Usar Cartão Novamente",
            message: "Mensagem"
          };
          
          data['insuranceErrorInfo'].forEach((item) => {
            itemsFormatted.push({
              card_flag: item.card_flag,
              code_error: item.code_error,
              use_card_again: item.use_card_again,
              message: item.message
            });
          });

          exportCSVFile(headers, itemsFormatted, fileTitle);

          NotificationService.successHandler(data, vm.labelsPage.success_download);
        }).catch(function (data) {
          console.log('error');
          NotificationService.errorHandler(data, vm.labelsPage.error_download);
        });
    } 

    function convertToCSV(objArray) {
      var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
      var str   = '';
  
      for (var i = 0; i < array.length; i++) {
          var line = '';

          for (var index in array[i]) {
              if (line != '') line += ','
              line += array[i][index];
          }
          str += line + '\r\n';
      }
      return str;
    }
  
    function exportCSVFile(headers, items, fileTitle) {
      if (headers) {
          items.unshift(headers);
      }

      var jsonObject       = JSON.stringify(items);
      var csv              = convertToCSV(jsonObject);
      var exportedFilenmae = fileTitle + '.csv' || 'export.csv';
      var blob             = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      var link             = document.createElement("a");

      if (link.download !== undefined) {
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", exportedFilenmae);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }   
    }
  
  }
})();